import { useParams } from "react-router";
import { useBranchData } from "../../../repository/branch/get";

const useSettingPage = () => {
  const params = useParams();
  const bId = params.bId as string;
  const { data, isLoading, isError } = useBranchData({ bId });
  return { branch: data, isLoading, isError };
};

export default useSettingPage;
